import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment';

@Pipe({
  name: 'datetime'
})
export class DateTimePipe implements PipeTransform {
  transform(value: Date, arg: string) : string {

    if (!value || !arg) {
      return '';
    }

    let date = moment(value);

    switch(arg){
      case 'dd mmm yyyy':
        return date.format('DD MMM YYYY');
      case 'dd/mm/yyyy':
        return date.format('DD/MM/YYYY');
      case 'dddd dd/mm/yyyy':
        return date.format('dddd DD/MM/YYYY');
      case 'dddd dd/mm/yyyy HH:mm':
        return date.format('dddd DD/MM/YYYY HH:mm');
      case 'dd/mm/yyyy hh:mm':
        return date.format('DD/MM/YYYY HH:mm');
      case 'ddd dd/mm/yy hh:mm':
        return date.locale('es').format('ddd DD/MM/YY HH:mm');
      case 'hh:mm':
        return date.format('HH:mm') + 'hs';
      case 'dd mmmm yyyy':
        let month = date.locale('es').format('MMMM');
        return date.format('DD [de] ')+month.charAt(0).toUpperCase()+month.slice(1)+date.format(' [de] YYYY');
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/datetime.ts